// @ts-nocheck
import { CATALOG_PRODUCT_POINTS_URL } from 'store/ProductCatalog/constants';
import { DISPLAY_TYPE_BLOCK } from 'store/ProductCatalog/controls/constants';
import { TARIFF_BRAND_NAME } from 'store/ProductDetails/constants';
import {
  DeviceInstallmentCount,
  DeviceInstallmentType,
} from 'store/ProductCatalog/products/constants';
import { convertHeader2024, convertLegacyHeader } from 'components/Header/data';
// import { convertLegacyRecentlyViewedProducts } from '../ProductDetails/dataConverter';

// TODO: go back mapping tariffIcons parameters to vitrina.
const convertLegacyParameter = (parameters, tariffIcons) => {
  const tariffSlugConvertToSrc = (slug) => {
    const tariffIconFiltered = (tariffIcons || []).filter((item) => item.slug === slug);
    return tariffIconFiltered[0] ? tariffIconFiltered[0].url : null;
  };

  return (parameters || []).map((item) => {
    const getValue = (slug, value) => {
      if (slug === 'IsUnlimited') {
        return '';
      }
      if (slug === 'Default') {
        return null;
      }
      return value;
    };
    return {
      label: item.name,
      value: getValue(item.slugIcon, item.value),
      unit: item.unit ? item.unit : null,
      url: item.link,
      hint: item.hint ? item.hint : null,
      iconUrl: tariffSlugConvertToSrc(item.slugIcon),
    };
  });
};

export const convertLegacyPagingData = ({ size, page, count }) => ({
  perPage: size,
  currentPage: page,
  totalCount: count,
});

const convertLegacyBundle = (
  isPromotionBundle,
  productPromotion,
  isPromoPriceMoreThanLimit,
  oldPriceIfBundleFormatted,
  additionalEquipmentBundleNote,
  mainEquipmentBundleNote,
  name,
) => {
  if (isPromotionBundle && productPromotion) {
    const oldPrice = parseInt((oldPriceIfBundleFormatted || '').replace(/\s+/g, ''), 10);

    return {
      state: true,
      oldPrice: productPromotion.valuePreposition && isPromoPriceMoreThanLimit ? oldPrice : 0,
      price: productPromotion.valuePreposition ? productPromotion.bundlePrice : oldPrice,
      mainDescription: productPromotion.valuePreposition ? name : mainEquipmentBundleNote,
      additionalDescription: additionalEquipmentBundleNote,
      mainDescriptionPrice: `${productPromotion.productPriceFormatted} ₽`,
      additionalDescriptionPrice: `${productPromotion.newPriceFormatted} ₽`,
      valuePreposition: productPromotion.valuePreposition,
      deliveryMethods: productPromotion.deliveryMethods,
      isOnlyWithPromo: productPromotion.isOnlyWithPromo,
      bundlePrice: productPromotion.bundlePrice,
      priceWithoutPromotion: productPromotion.priceWithoutPromotion,
    };
  }

  return { state: false };
};

const getDataLayerObject = (seoObject) => (seoObject || {}).dataLayerObject || {};

const getSEOList = (seoObject) => (getDataLayerObject(seoObject).ecommerce || {}).impressions || [];

/** content promotion compare and convert */
const convertPromoCampaignContent = (contentPromotion, remainOp, shopActionCampaigns) => {
  if ((shopActionCampaigns || []).length !== 0) {
    return (shopActionCampaigns[0] || {}).description || '';
  }
  return (contentPromotion || {}).title || '';
};

/** Возвращает массив оплат либо частями либо в рассрочку либо все вместе */
const convertPromoInstallments = (bnpl = {}, creditDetails = {}) => {
  const {
    available: creditAvailable,
    content: creditContent,
    monthPrice: creditPayment,
    monthCount: credditMonthCount,
  } = creditDetails;
  const { available: bnplAvailable, bnplPayment, content: bnplContent } = bnpl;

  const { namePayment, shopProductCartShortInfo } = creditContent || {};
  const { isBnplFeatureShown, shopBnplText } = bnplContent || {};

  const showBnpl = bnplAvailable && isBnplFeatureShown;
  const showInstallment = creditAvailable && !bnplAvailable;

  if (showBnpl) {
    return [
      {
        count: DeviceInstallmentCount.BNPL,
        price: bnplPayment,
        text: shopBnplText,
        type: DeviceInstallmentType.BNPL,
      },
    ];
  }

  if (showInstallment) {
    return [
      {
        count: credditMonthCount,
        price: creditPayment,
        text: namePayment,
        tooltip: shopProductCartShortInfo,
        type: DeviceInstallmentType.INSTALLMENT,
      },
    ];
  }

  return [];
};
// ===

// TODO: create task for remapping of legacy products
export const convertLegacyProducts = (initialList, tariffParameterIcons) => {
  const list = initialList || [];
  const convertList = ({
    name,
    shortName,
    brandName,
    regionProduct,
    thumbImageUrlConverted,
    urlSlug,
    parameters,
    rate,
    feedbackCount,
    contentPromotion,
    dpcId,
    badges,
    isPromotionBundle,
    productPromotion,
    isTariff,
    isPromoPriceMoreThanLimit,
    oldPriceIfBundleFormatted,
    additionalEquipmentBundleNote,
    mainEquipmentBundleNote,
    price,
    mainCollectionName,
    bnpl,
    creditDetails,
    ...data
  }) => ({
    id: data.id,
    title: name,
    shortTitle: shortName || '',
    // TODO: remove when SHOP-3909 is done
    brandName: isTariff ? TARIFF_BRAND_NAME : brandName,
    price: {
      value: price?.value,
      oldValue: price?.oldValue,
    },
    article: data.article,
    highlight: data?.highlight,
    isTariff,
    dpcId,
    remains: regionProduct.remain,
    promotionId: (productPromotion || {}).id || null,
    promotionBundle: convertLegacyBundle(
      isPromotionBundle,
      productPromotion,
      isPromoPriceMoreThanLimit,
      oldPriceIfBundleFormatted,
      additionalEquipmentBundleNote,
      mainEquipmentBundleNote,
      name,
    ),
    thumbUrl: thumbImageUrlConverted, // need image of 200/200 or 400/400
    url: `/shop/details/${urlSlug}/`,
    characteristics: convertLegacyParameter(parameters, tariffParameterIcons),
    feedback: {
      average: rate,
      count: feedbackCount,
      url: `/shop/details/${urlSlug}/otzyvy/`,
    },
    urlSlug,
    hasRemainsOffice: data.hasRemainsOffice,
    hasRemainsShop: data.hasRemainsShop,
    hasLeasing: data.hasLeasing,
    isPreorder: data.isPreorder,
    delivery: data.delivery,
    isOutOfStock: data.isOutOfStock,
    outOfStockReasonSlug: data.outOfStockReasonSlug,
    outOfStockMessageTemplate: data.outOfStockMessageTemplate,

    // TODO: figure out which preorder Announcement we should use, this one or the global one
    preorderAnnouncementTemplate: data.preorderAnnouncement,
    preorderStartDate: data.preorderStartDate,
    contentPromotion: convertPromoCampaignContent(
      contentPromotion,
      regionProduct.remainOp,
      regionProduct.shopActionCampaigns,
    ),
    contentPromotionUrl: (contentPromotion || {}).url,
    hasActionCampaigns: (regionProduct.shopActionCampaigns || []).length !== 0,
    badges: badges || [],
    offices: [],
    esim: data.esim,
    partnerSlug: data.partnerSlug,
    // Информация о покупке товара либо оплатой частями, либо в рассрочку. Пока реализовано только bnpl.
    installments: convertPromoInstallments(bnpl, creditDetails),
    mainCollectionName,
  });
  return list.map(convertList);
};

const convertLegacyBody = ({ navigation, search = {}, ...data }) => ({
  title: data.title,
  dataLayerObject: getDataLayerObject(data.seo),
  productsSEOList: getSEOList(data.seo),
  mainCollectionId: data.mainCollectionId,
  mainCollectionName: data.mainCollectionName,
  subCollectionName: data.subCollectionName,
  subCollectionId: data.subCollectionId,
  metaTitle: data.metaTitle,
  baseUrl: data.baseUrl,
  breadcrumbs: data.breadcrumbs,
  outOfStock: data.outOfStock,
  query: data.query,
  isTariff: data.isTariff,
  tags: (data.tags || []).map(({ name, slug, isChecked }) => ({
    name,
    url: `${data.baseUrl}tag/${slug}/`,
    slug,
    isChecked,
  })),

  // TODO: remove once SHOP-2784 is done
  isSearchPage:
    typeof data.isSearchPage !== 'undefined' ?
      data.isSearchPage
    : typeof data.query !== 'undefined',

  searchInfo: data.searchInfo || {
    messageTemplate: 'По вашему запросу "{{query}}" найдено {{results}} в {{inCategories}}',
    noResultTemplate:
      `${
        data.query ?
          'По вашему запросу "{{query}}" ничего не найдено'
        : 'Задан пустой поисковый запрос'
      }` +
      '<Emoji name="smile-sad"></Emoji>' +
      'Попробуйте уточнить запрос<br /><br />' +
      'Или <a href="/shop/catalog/">перейти в каталог</a><br /><br />' +
      '<Button href="/shop/catalog/" isLarge="true">Перейти</Button>',
    inCategories: 5,
  },

  requestUrl: data.requestUrl || '/shop/catalog/telefony/',
  navigation: {
    title: navigation.title,
    referenceTitle: navigation.referenceTitle,
    collections: navigation.collections,
    contacts: navigation.contacts,
  },
  search: {
    placeholder: search.placeholder,
    url: search.url,
    suggestionsUrlTemplate: '/shop/searchsuggestion/shopsearch/?startswith={{query}}',
  },

  // TODO: Remove top condition, when SHOP-2717 is done
  products:
    Array.isArray(data.products) ?
      {
        list: convertLegacyProducts(data.products, data.tariffParameterIcons),
        updateMethodUrl: '/shop/getproductslistbyfilters/',
        paging: convertLegacyPagingData(data.paging || {}),
        requestUnexpectedErrorMessage: 'Что-то пошло не так, фильтрация не применена',
        requestEmptyListErrorMessage: 'Нет товаров, удовлетворяющих условиям поиска',
      }
    : {
        ...data.products,
        list: convertLegacyProducts(data.products.list, data.tariffParameterIcons),
      },

  preorderDetails: {
    announcementTemplate: '<p>Старт продаж {{startDate}} года</p>',
  },

  controls: {
    ...data.controls,
    sortBy: String((data.controls || {}).sortBy), // convert sortBy to string
    displayType: DISPLAY_TYPE_BLOCK,
  },

  // TODO: Удалить. Временная заглушка для SHOP-7419
  // recentlyViewedProducts: convertLegacyRecentlyViewedProducts(data),
  recentlyViewedProducts: {
    isEnabled: true,
    url: '/shop/getproductdetailslastviewedproducts/',
    data: {
      product_id: 196759,
    },
  },

  filters: data.filters,
  filtersWithoutCounters: data.filtersWithoutCounters,
  bonusService: data.bonusServices,
  deliveryDetails: {
    ...data.deliveryDetails,
    productPointsUrl: CATALOG_PRODUCT_POINTS_URL,
    takeaway: {
      ...(data.deliveryDetails || {}).takeaway,
      title: 'Самовывоз',
      price: 0,
      /**
       * Для витрины, содержимое контента берется из
       * public DeliveryRuleOPViewModel DeliveryAndPayment
       */
      content:
        '<p>Как зарезервировать и получить свой заказ:</p>' +
        '<p>1. Выберите подходящий салон<br/>2. Заполните и отправьте форму заявки<br/>' +
        '3. Дождитесь смс с номером заказа<br/>' +
        '4. Заберите заказ в рабочие часы выбранного салона</p>' +
        '<p>Заказ хранится в салоне 48 часов. Для продления позвоните по номеру - 8 800 725-5-725</p>',
      url: `${data.baseUrl}delivery/takeaway/`,
      views: [
        {
          title: 'На карте',
          slug: 'map',
          url: `${data.baseUrl}delivery/takeaway/map/`,
        },
        {
          title: 'Списком',
          slug: 'list',
          url: `${data.baseUrl}delivery/takeaway/list/`,
        },
      ],
      referenceTemplate: 'Самовывоз сегодня из {{offices_count}} точек',
    },
  },
  seo: data.seo,
  seoSmallDescription: data.seoSmallDescription,
  tariffParameterIcons: data.tariffParameterIcons,
  promoBannerMarkup: data.promoBannerMarkup,
  promoBanners: data.promoBanners,
  showFilters: data.showFilters,
  remainsOnly: data.remainsOnly,
  officeBuy: data.officeBuy,
});

export const convertLegacyModel = ({
  header,
  body,
  footer,
  settings: { common: settings, ...common },
}) => ({
  header: convertLegacyHeader(header),
  specialProjectHeader: convertHeader2024(header, common?.meta),
  // @ts-ignore
  body: convertLegacyBody(body),
  footer,
  common: {
    ...common,
    settings: {
      compareUrl: '/shop/comparison/',
      compareCookieName: 'beeline.shop.products.comparison_98140',
      lastKnownResolutionCookieName: 'lastKnownResolution',
      ...settings,
      lastKnownResolution: settings.lastKnownResolution ? Number(settings.lastKnownResolution) : '',
    },
  },
  settings: common,
});
